import { render, staticRenderFns } from "./IndexColaboradorApp.vue?vue&type=template&id=0c64c1c6&"
import script from "./IndexColaboradorApp.vue?vue&type=script&lang=js&"
export * from "./IndexColaboradorApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports